import React from 'react';
import { ROLES_ENQUETE, OPERATIONS, OUTILS_COLLECTE } from '../../constants/formOptions';
import { Field, NumberInput, YesNo, MultiSelect } from './fields';

const Experience = ({ data, errors, onChange }) => (
  <>
    <h2>Expérience</h2>
    <p className="section-desc">Les trois blocs sont obligatoires pour ce poste.</p>

    <div className="section">
      <h3 className="section-title">Enquêtes auprès des ménages</h3>
      <Field
        label="Avez-vous collecté, supervisé ou coordonné des enquêtes auprès des ménages ?"
        required
        error={errors.experience_enquetes_menages}
      >
        <YesNo
          name="experience_enquetes_menages"
          value={data.experience_enquetes_menages}
          onSelect={(v) => onChange({ experience_enquetes_menages: v })}
        />
      </Field>

      {data.experience_enquetes_menages && (
        <div className="fade-in">
          <div className="form-row two-cols">
            <Field label="Années d'expérience" required error={errors.annees_experience}>
              <NumberInput
                max={50}
                value={data.annees_experience}
                error={errors.annees_experience}
                onChange={(v) => onChange({ annees_experience: v })}
              />
            </Field>
          </div>
          <Field label="Rôles tenus" required error={errors.roles_enquetes}>
            <MultiSelect
              options={ROLES_ENQUETE}
              selected={data.roles_enquetes}
              onChange={(v) => onChange({ roles_enquetes: v })}
            />
          </Field>
          <Field
            label="Enquêtes réalisées"
            required
            error={errors.operations}
            hint="Les enquêtes de santé et de vaccination sont un atout."
          >
            <MultiSelect
              options={OPERATIONS}
              selected={data.operations}
              onChange={(v) => onChange({ operations: v })}
            />
          </Field>
          <Field label="Précisions (facultatif)">
            <textarea
              rows={3}
              value={data.description_experience}
              onChange={(e) => onChange({ description_experience: e.target.value })}
              placeholder="Années, zones couvertes, responsabilités…"
            />
          </Field>
        </div>
      )}
    </div>

    <div className="section">
      <h3 className="section-title">Équipes de terrain</h3>
      <Field
        label="Avez-vous géré et supervisé des équipes de terrain ?"
        required
        error={errors.experience_gestion_equipes}
      >
        <YesNo
          name="experience_gestion_equipes"
          value={data.experience_gestion_equipes}
          onSelect={(v) => onChange({ experience_gestion_equipes: v })}
        />
      </Field>
      {data.experience_gestion_equipes && (
        <div className="form-row two-cols fade-in">
          <Field label="Nombre maximal d'agents encadrés" required error={errors.nombre_agents_encadres}>
            <NumberInput
              max={1000}
              value={data.nombre_agents_encadres}
              error={errors.nombre_agents_encadres}
              onChange={(v) => onChange({ nombre_agents_encadres: v })}
            />
          </Field>
        </div>
      )}
    </div>

    <div className="section">
      <h3 className="section-title">Collecte sur tablette / smartphone</h3>
      <Field label="Outils maîtrisés" required error={errors.outils_collecte}>
        <MultiSelect
          options={OUTILS_COLLECTE}
          selected={data.outils_collecte}
          onChange={(v) => onChange({ outils_collecte: v })}
        />
      </Field>
      <div className="form-row two-cols">
        <Field label="Nombre d'opérations réalisées sur tablette">
          <NumberInput
            max={50}
            value={data.nombre_operations_tablette}
            onChange={(v) => onChange({ nombre_operations_tablette: v })}
          />
        </Field>
      </div>
    </div>
  </>
);

export default Experience;
